var render = function (_h,_vm) {var _c=_vm._c;return _c('input',_vm._g({staticClass:"form-control",class:_vm.props.customClass,attrs:{"placeholder":_vm.props.placeholder,"name":_vm.props.name,"disabled":_vm.props.disabled,"readonly":_vm.props.readonly},domProps:{"value":_vm.props.value}},_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }